<template>
    <DTable
        :items="debtLossInvoices"
        :fields="getFields()"
    >
        <template #customer_id="{item}">
            <td v-if="userPermissions.includes('customer.view')">
                <Link :href="customerInvoicesRoute(item)">
                    {{ item.customer_id }}
                </Link>
            </td>
            <td v-else>
                {{ item.customer_id }}
            </td>
        </template>
        <template #invoice_id="{item}">
            <td v-if="userPermissions.includes('invoice.view')">
                <Link :href="showInvoiceRoute(item)">
                    {{ item.id }}
                </Link>
            </td>
            <td v-else>
                {{ item.id }}
            </td>
        </template>
        <template #invoice_date="{item}">
            <td>{{ setDateFormat(item.invoice_date) }}</td>
        </template>
        <template #invoice_total="{item}">
            <td
                class="text-right"
                :class="{'table-text-color-red': item.total_amount < 0}"
            >
                {{ priceFormatForDisplay(item.total_amount, 2, item.customer.market_region_id) }}
            </td>
        </template>
        <template #open_item_amount="{item}">
            <td
                class="text-right"
                :class="{'table-text-color-red': item.open_item_amount < 0}"
            >
                {{ priceFormatForDisplay(item.open_item_amount, 2, item.customer.market_region_id) }}
            </td>
        </template>
        <template #debtloss_date="{item}">
            <td>{{ setDateFormat(item.debt_loss_date) }}</td>
        </template>
        <template #debtloss_user="{item}">
            <td>{{ debtLossUser(item) }}</td>
        </template>
        <template #sanity="{item}">
            <td>{{ __('customers.common.sanity.' + item.customer.sanity) }}</td>
        </template>
    </DTable>
</template>

<script>
import priceFormat from '~@/Mixins/priceFormat'
export default {
    name: 'DebtLossInvoicesTable',
    mixins: [
        priceFormat
    ],
    props: {
        debtLossInvoices: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    computed: {
        userPermissions () {
            return this.$page.props.auth.permissions
        }
    },
    methods: {
        getFields () {
            return [
                { key: 'customer_id', label: this.__('tools.debt_loss_invoices.table.customer_id') },
                { key: 'invoice_id', label: this.__('tools.debt_loss_invoices.table.invoice_id') },
                { key: 'invoice_date', label: this.__('tools.debt_loss_invoices.table.invoice_date') },
                { key: 'invoice_total', label: this.__('tools.debt_loss_invoices.table.invoice_total') },
                { key: 'open_item_amount', label: this.__('tools.debt_loss_invoices.table.open_item_amount') },
                { key: 'debtloss_date', label: this.__('tools.debt_loss_invoices.table.debtloss_date') },
                { key: 'debtloss_user', label: this.__('tools.debt_loss_invoices.table.debtloss_user') },
                { key: 'sanity', label: this.__('tools.debt_loss_invoices.table.sanity') }
            ]
        },
        showInvoiceRoute (invoice) {
            return this.$route('customers.customers.invoices.show', {
                customer: invoice.customer_id,
                invoice: invoice.id
            })
        },
        customerInvoicesRoute (invoice) {
            return this.$route('customers.customers.invoices.index', { customer: invoice.customer_id })
        },
        debtLossUser (item) {
            return item.debt_loss_user !== null ? item.debt_loss_user.name : ''
        }
    }
}
</script>

<style scoped>

</style>
